import React from 'react';
import { Card, CardContent } from './ui/card';
import { Instagram, Facebook, Youtube, Linkedin, Twitter } from 'lucide-react';

const SocialMedia = () => {
  const socials = [
    {
      icon: Linkedin,
      name: 'LinkedIn',
      description: 'Corporate training, recruitment & thought leadership',
      url: 'https://www.linkedin.com/feed/',
      gradient: 'from-[#0077B5] to-[#00A0DC]',
    },
    {
      icon: Instagram,
      name: 'Instagram',
      description: 'Classes, reels, culture & success stories',
      url: 'https://www.instagram.com/cloudxai.official',
      gradient: 'from-[#E1306C] to-[#F77737]',
    },
    {
      icon: Youtube,
      name: 'YouTube',
      description: 'Demos, webinars & launches',
      url: 'https://www.youtube.com/@CloudXAI.Official',
      gradient: 'from-[#FF0000] to-[#CC0000]',
    },
    {
      icon: Facebook,
      name: 'Facebook',
      description: 'Community & local engagement',
      url: 'https://www.facebook.com/cloudxai.official',
      gradient: 'from-[#1877F2] to-[#0C63D4]',
    },
    {
      icon: Twitter,
      name: 'X (Twitter)',
      description: 'Tech updates & announcements',
      url: 'https://x.com/Cloudxai120847',
      gradient: 'from-[#1DA1F2] to-[#0C85D0]',
    },
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#0B0F1A]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-4 font-['Space_Grotesk']">
            Connect With <span className="bg-gradient-to-r from-[#00E5FF] to-[#1DE9B6] bg-clip-text text-transparent">CloudXAI</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#00E5FF] to-transparent mx-auto mb-4"></div>
          <p className="text-xl text-[#9CA3AF] max-w-3xl mx-auto">
            Follow us on social platforms for training updates, hiring opportunities, tech insights, events, and announcements
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {socials.map((social, index) => {
            const Icon = social.icon;
            return (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="block group"
              >
                <Card className="bg-[#111827] border-2 border-[#00E5FF]/20 hover:border-[#00E5FF]/60 hover:shadow-xl hover:shadow-[#00E5FF]/20 transition-all duration-300 hover:-translate-y-1">
                  <CardContent className="p-6">
                    <div className="flex items-start space-x-4">
                      <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${social.gradient} flex items-center justify-center flex-shrink-0 group-hover:scale-110 group-hover:shadow-lg group-hover:shadow-[#00E5FF]/30 transition-all duration-300`}>
                        <Icon className="w-7 h-7 text-white" />
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-white mb-2 group-hover:text-[#00E5FF] transition-colors font-['Space_Grotesk']">
                          {social.name}
                        </h3>
                        <p className="text-[#9CA3AF] text-sm leading-relaxed">{social.description}</p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </a>
            );
          })}
        </div>

        <div className="text-center">
          <p className="text-lg text-[#00E5FF] font-medium">Follow CloudXAI on Social Media</p>
        </div>
      </div>
    </section>
  );
};

export default SocialMedia;
